import { createSlice } from "@reduxjs/toolkit";

const detallesreclamoState = {
  datadetallesreclamo: [],
  statusEstadoDetalleReclamo: 0,
  errorEstadoDetalleReclamo: "",
  isDetalleReclamoFetching: false,
}

export const detallesreclamoSlice = createSlice({
  name: "detallesreclamo",
  initialState: detallesreclamoState,
  reducers: {
    StoreDetalleReclamoData: (state, actions) => {
      state.datadetallesreclamo = actions.payload;
    },
    StoreEstadoDetalleReclamoData: (state, actions) => {
      state.statusEstadoDetalleReclamo = actions.payload;
      state.errorEstadoDetalleReclamo = actions.payload;
      state.isDetalleReclamoFetching = actions.payload;
    }, 
    ResetDetalleReclamoData: () => detallesreclamoState,
  }
});

export const { StoreDetalleReclamoData, StoreEstadoDetalleReclamoData, ResetDetalleReclamoData } = detallesreclamoSlice.actions;

export default detallesreclamoSlice.reducer;